export default __webpack_public_path__ + "static/media/Y_Ygara.0d7637f7.svg";